import Hero from './Hero/Hero'
import Stats from './Stats/Stats'
import About from './About/About'
import Products from './Products/Products'
import Contact from './Contact/Contact'
import Projects from './Projects/Projects'
import './Landing.scss'

const Landing: React.FC = () => {
	return (
		<div className='landing'>
			<Hero />
			<Stats />
			<About />
			<Products />
			<Projects />
			<Contact />
		</div>
	)
}

export default Landing
